import permissionsJson from 'modules/application/detail/permissions.json';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
export class ApplicationTeamService {
    static $inject = ['BlipService', 'MESSAGINGHUBDOMAIN', 'BLIP_DOMAIN', 'AuthenticationService', 'AccountService2'];
    constructor(BlipService, MESSAGINGHUBDOMAIN, BLIP_DOMAIN, AuthenticationService, AccountService2) {
        this.BlipService = BlipService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.AuthenticationService = AuthenticationService;
        this.AccountService2 = AccountService2;
        this.loadPermissionsArray();
    }
    loadPermissionsArray() {
        this.permissionsArray = Object.keys(permissionsJson).map(key => {
            const value = permissionsJson[key];
            return {
                key,
                id: value.id,
                title: value.title,
                claim: value.claim,
                description: value.description,
            };
        });
    }
    async getApplicationUser(applicationId, userEmail) {
        try {
            await this.blipServiceConnect();
            const applicationUserData = this.processApplicationUserData(applicationId, userEmail);
            return this.BlipService.sendCommand({
                to: `postmaster@portal.${this.BLIP_DOMAIN}`,
                method: 'get',
                uri: `/applications/${applicationUserData.ApplicationIdentity}/users/${applicationUserData.UserIdentity}`,
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async getUserApplicationPermissions(shortName) {
        const user = await this.AccountService2.me();
        const userIdentity = encodeURIComponent(user.identity);
        try {
            await this.blipServiceConnect();
            const applicationIdentity = `${shortName}@${this.MESSAGINGHUBDOMAIN}`;
            return await this.BlipService.sendCommand({
                to: `postmaster@portal.${this.BLIP_DOMAIN}`,
                method: 'get',
                uri: `/applications/${applicationIdentity}/users/${userIdentity}/permissions`,
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async getUserApplicationPermissionModel(shortName) {
        const permissions = await this.getUserApplicationPermissions(shortName);
        return this.convertIrisPermissionsToMessagingHub(permissions.items);
    }
    convertIrisPermissionsToMessagingHub(permissions) {
        return permissions.map((irisPermission) => {
            const permission = this.permissionsArray.find(i => i.id === irisPermission.permissionId);
            if (permission) {
                return {
                    permissionClaim: permission.claim,
                    permissionAction: this.getPermissionAction(irisPermission.actions),
                };
            }
        }).filter(x => x);
    }
    getPermissionAction(actions) {
        let permissionAction = 0;
        if (actions.includes('read')) {
            permissionAction += 1;
        }
        if (actions.includes('write')) {
            permissionAction += 2;
        }
        return permissionAction;
    }
    async getOrCreateApplicationUser(applicationId, userEmail, tenantId) {
        try {
            return await this.getApplicationUser(applicationId, userEmail);
        }
        catch (e) {
            const error = JSON.parse(e);
            if (error.reason.code === 67
                && error.reason.description === 'The requested resource was not found') {
                return await this.setApplicationUser(applicationId, userEmail, tenantId);
            }
            else {
                throw error;
            }
        }
    }
    async setApplicationUser(applicationId, userEmail, tenantId = '') {
        try {
            await this.blipServiceConnect();
            const applicationUserData = this.processApplicationUserData(applicationId, userEmail);
            const tenantQuery = tenantId ? `?tenantId=${tenantId}` : '';
            return this.BlipService.sendCommand({
                to: `postmaster@portal.${this.BLIP_DOMAIN}`,
                method: 'set',
                type: 'application/vnd.lime.identity',
                uri: `/applications/${applicationUserData.ApplicationIdentity}/users${tenantQuery}`,
                resource: applicationUserData.UserIdentityResource,
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async deleteApplicationUser(applicationId, userEmail) {
        try {
            await this.blipServiceConnect();
            const applicationUserData = this.processApplicationUserData(applicationId, userEmail);
            const messagingHubCommandWithDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
            const uri = messagingHubCommandWithDelegation ?
                `/applications/${applicationUserData.ApplicationIdentity}/users/${applicationUserData.UserIdentity}?messagingHubCommandWithDelegation=${messagingHubCommandWithDelegation}` :
                `/applications/${applicationUserData.ApplicationIdentity}/users/${applicationUserData.UserIdentity}`;
            return this.BlipService.sendCommand({
                to: `postmaster@portal.${this.BLIP_DOMAIN}`,
                method: 'delete',
                uri: uri,
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async setApplicationPermissions(applicationId, permissions) {
        await this.blipServiceConnect();
        const messagingHubCommandWithDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
        const uri = messagingHubCommandWithDelegation ?
            `/applications/${applicationId}@${this.MESSAGINGHUBDOMAIN}/permissions?messagingHubCommandWithDelegation=${messagingHubCommandWithDelegation}` :
            `/applications/${applicationId}@${this.MESSAGINGHUBDOMAIN}/permissions`;
        return this.BlipService.sendCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'set',
            type: 'application/vnd.lime.collection+json',
            uri: uri,
            resource: {
                itemType: 'application/vnd.iris.portal.user-permission+json',
                items: permissions,
            },
        });
    }
    async setApplicationUserPermission(applicationId, userEmail, permission) {
        try {
            await this.blipServiceConnect();
            const applicationUserData = this.processApplicationUserData(applicationId, userEmail);
            return this.BlipService.sendCommand({
                to: `postmaster@portal.${this.BLIP_DOMAIN}`,
                method: 'set',
                type: 'application/vnd.iris.portal.user-permission+json',
                uri: `/applications/${applicationUserData.ApplicationIdentity}/users/${applicationUserData.UserIdentity}/permissions`,
                resource: {
                    permissionId: permission.permissionId,
                    actions: permission.actions,
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async deleteApplicationUserPermission(applicationId, userEmail, permissionId) {
        try {
            await this.blipServiceConnect();
            const applicationUserData = this.processApplicationUserData(applicationId, userEmail);
            return this.BlipService.sendCommand({
                to: `postmaster@portal.${this.BLIP_DOMAIN}`,
                method: 'delete',
                uri: `/applications/${applicationUserData.ApplicationIdentity}/users/${applicationUserData.UserIdentity}/permissions/${permissionId}`,
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    processApplicationUserData(applicationId, user) {
        return {
            ApplicationIdentity: encodeURIComponent(`${applicationId}@${this.MESSAGINGHUBDOMAIN}`),
            UserIdentity: encodeURIComponent(`${encodeURIComponent(user)}@${this.BLIP_DOMAIN}`),
            UserIdentityResource: `${encodeURIComponent(user)}@${this.BLIP_DOMAIN}`,
        };
    }
    async blipServiceConnect() {
        if (!(await this.BlipService.isConnected())) {
            await this.BlipService.connect(encodeURIComponent(this.AuthenticationService.email), this.AuthenticationService.token);
        }
    }
}
ApplicationTeamService.$inject = ['BlipService', 'MESSAGINGHUBDOMAIN', 'BLIP_DOMAIN', 'AuthenticationService', 'AccountService2'];
export class Permission {
    static $inject = ['permissionId', 'actions', 'userIdentity'];
    constructor(permissionId, actions, userIdentity) {
        'ngInject';
        this.permissionId = permissionId;
        this.actions = actions;
        this.userIdentity = userIdentity;
    }
    static fromMessagingHubPermission(messagingHubPermission, userIdentity, setNoneEnabled) {
        const actions = [];
        if (messagingHubPermission.permissionAction & 1) {
            actions.push('read');
        }
        if (messagingHubPermission.permissionAction & 2) {
            actions.push('write');
        }
        if (setNoneEnabled && messagingHubPermission.parent != undefined && actions.length === 0) {
            actions.push('none');
        }
        return new Permission(messagingHubPermission.id, actions, userIdentity);
    }
}
